// extracted by mini-css-extract-plugin
module.exports = {"lightboxImage":"Review_lightboxImage__rxol2","leadingReview":"Review_leadingReview__9R2a8"};